export enum HourPartitionColumn {
    Hour = "hour"
}